import * as React from "react";
import {
  Text,
  Image,
  StyleSheet,
  View,
  TouchableOpacity,
  Dimensions,
  Platform,
  Linking,
} from "react-native";
import { useRoute } from "@react-navigation/native";
import { ScrollView } from "react-native-gesture-handler";
import GlobalStyles from "../../components/GlobalStyles";
import MenuBar from "../../components/headers/MenuBar";
import StatusBar from "../../components/headers/StatusBar";
import FooterBarWide from "../../components/footerBarWide";
import { AntDesign } from "@expo/vector-icons";
import CustomIcon from "../../components/CustomIcon";
import FavouriteIcon from "../../components/FavoriteToggleIconWeb";
import {
  modifyPartner,
  resetPartnerData,
} from "../../redux/actions/PartnerActions";
import { user_force_refresh } from "../../redux/actions/UserActions";
import { useNavigation } from "@react-navigation/native";
const PartnerBGimage = require("../../assets/images/partners/partner_bg_w.png");
import { useSelector } from "react-redux";
import { updateRecentPartners } from "../../redux/actions/PartnerActions";
import Colors from "../../utilities/Color.js";
import BackButton from "../../components/BackButton";
import InstoreMap from "../../components/buy/InstoreMap";
import { getSingleInstoreOffer, unloadSingleInstoreOffer } from "../../redux/actions/OfferActions";
import Locations from "../../components/buy/Locations";


export default function WebInstoreOfferDetailScreen() {
  const navigation = useNavigation();
  const route = useRoute();
  const routeOffer = route.params.offer;
  const routeOfferId = route.params.offerId;
  const win = Dimensions.get("window");
  const [shouldShowId, setShouldShowIndex] = React.useState(-1);

  const [offer, setOffer] = React.useState({});
  const [offerLoaded, setOfferLoaded] = React.useState(false);

  const hasCards = useSelector((state) => state.card.cards).length != 0;

  const singletonOffer = useSelector((state) => state.offers.singleInstoreOffer);
  const singletonOfferLoaded = useSelector((state) => state.offers.singleInstoreOfferLoaded);

  React.useEffect(() => {
    if (!offerLoaded) {
      if (routeOffer != undefined) {
        setOffer(routeOffer);
        setOfferLoaded(true);
      } else {
        if (singletonOfferLoaded) {
          setOffer(singletonOffer);
          setOfferLoaded(true);
        } else if (routeOfferId != undefined) {
          getSingleInstoreOffer(routeOfferId);
        }
      }
    }
    return function cleanup() {
      unloadSingleInstoreOffer();
    }
  }, [offerLoaded, singletonOfferLoaded]);

  return (
    <View style={GlobalStyles.containerW}>
      <ScrollView style={styles.scrollArea}>
        {win.width > 768 ? (
          <View style={GlobalStyles.fullHeaderBarY}>
            <View style={{ height: 100 }} />
            {/* <MenuBar data="1" /> */}
            <View style={GlobalStyles.topHeaderTitelContainerForWeb}>
              <View style={[GlobalStyles.headerContainerKLYellow, { alignSelf: "flex-start" }]}>
                <View style={GlobalStyles.headerTextYellowForweb}>
                  <View style={styles.rightTopBodyContainer}>
                    <View style={GlobalStyles.backIconContainerForWeb} >
                      <BackButton />
                    </View>
                    <View style={styles.imageThumbnailPadding}>
                      <Image
                        style={[styles.imageThumbnail, { height: 86, }]}
                        source={{ uri: offer.logoUrl }}
                      />
                    </View>
                    <View style={{ marginLeft: 15 }}>
                      <Text style={GlobalStyles.headingStyle}>{offer.advertiserName}</Text>
                    </View>
                  </View>
                </View>
              </View>
            </View>
          </View>
        ) : (
          <View style={GlobalStyles.fullHeaderBarW}>
            <StatusBar data="BM" />
            <View style={GlobalStyles.headerContainerKL}>
              <View style={GlobalStyles.headerTextBoxTwo}>
                <View style={GlobalStyles.headerTextColApp}>
                  <Text style={GlobalStyles.headingStyle}>
                    {offer.advertiserName}
                  </Text>
                  <Text style={GlobalStyles.subheaderStyle}>
                    {offer.categoryName}
                  </Text>
                </View>
                <View style={styles.imageThumbnailPadding}>
                  <Image
                    style={styles.imageThumbnail}
                    source={{ uri: offer.logoUrl }}
                  />
                </View>
              </View>
            </View>
          </View>
        )}
        {/* content body */}
        <View style={GlobalStyles.SD_Body_Container}>
          <View style={GlobalStyles.SD_Flex_Container}>
            <View style={GlobalStyles.SD_ColA}>
              <View style={styles.investedTopCotainer}>
                <View style={styles.investedDetailContainer}>
                  <View style={styles.investedTextContainer}>
                    <Text style={styles.investedDetail}>
                      {offer.offerTitle}
                    </Text>
                  </View>
                  <View style={styles.favouriteIconContainer}>
                    <FavouriteIcon
                      isFavorite={offer.isFavourite}
                      offerId={offer.offerId}
                    />
                  </View>
                </View>
                <View style={styles.imageContainer}>
                  <Image
                    style={styles.bigImageThumbnail}
                    source={{ uri: offer.coverShotUrl }}
                  />
                </View>
              </View>
            </View>
            <View style={GlobalStyles.SD_ColB}>
              <View>
                {hasCards ? (
                  <View style={styles.cardButtonContainer}>
                    <TouchableOpacity
                      style={styles.linkedcard}
                      activeOpacity={0.5}
                      onPress={() => {
                        navigation.navigate("WebBuyAction");
                      }}
                    >
                      <View style={{ marginRight: 10 }}>
                        <CustomIcon
                          name="icon-creditcard"
                          size={24}
                          color={Colors.MIDBLUE}
                        />
                      </View>
                      <Text style={styles.linkedCardTextStyle}>
                        CARD LINKED PARTNER
                      </Text>
                    </TouchableOpacity>
                  </View>
                ) : (
                  <View style={styles.cardButtonContainer}>
                    <TouchableOpacity
                      style={styles.NotLinkedcard}
                      activeOpacity={0.5}
                      onPress={() => {
                        navigation.navigate("WebBuyAction");
                      }}
                    >
                      <View style={{ marginRight: 10 }}>
                        <CustomIcon
                          name="icon-creditcard"
                          size={24}
                          color={Colors.WHITE}
                        />
                      </View>
                      <Text style={styles.NotLinkedCardTextStyle}>
                        LINK YOUR CARD
                      </Text>
                    </TouchableOpacity>
                  </View>
                )}
              </View>

              <View>
                <Text style={styles.descriptionDetail}>
                  {offer.description}
                </Text>
              </View>
              <View style={styles.fixedTextContainer}>
                <Text style={styles.bodyIntro}>
                  Shop using Aura to receive cashback and help community groups
                  across Australia.
                </Text>
              </View>
            </View>
          </View>
          <View style={GlobalStyles.SD_Full_Width_Container}>
            <View>
              {offer.locations == undefined ? (
                <></>
              ) : (
                <InstoreMap locations={offer.locations} />
              )}

            </View>

            <View style={styles.infoLinkContainer}>
              <TouchableOpacity
                showId={shouldShowId == 2}
                onPress={() =>
                  shouldShowId == 2
                    ? setShouldShowIndex(-1)
                    : setShouldShowIndex(2)
                }
              >
                <View style={[styles.upInfoContainer, { borderTopWidth: 1 }]}>
                  <View style={styles.upInfoLeftContainer}>
                    <Text style={styles.infoLink}>Locations</Text>
                  </View>
                  <View style={styles.arrowRightContainer}>
                    <AntDesign name="down" size={15} color="#A5A5A5" />
                  </View>
                </View>
              </TouchableOpacity>
              <View style={styles.hiddenInfoContainer}>
                {shouldShowId == 2 ? (
                  <View>
                    <Locations locations={offer.locations} />
                  </View>
                ) : null}
              </View>
              <TouchableOpacity
                showId={shouldShowId == 0}
                onPress={() =>
                  shouldShowId == 0
                    ? setShouldShowIndex(-1)
                    : setShouldShowIndex(0)
                }
              >
                <View style={[styles.upInfoContainer, { borderTopWidth: 1 }]}>
                  <View style={styles.upInfoLeftContainer}>
                    <Text style={styles.infoLink}>About this Brand</Text>
                  </View>
                  <View style={styles.arrowRightContainer}>
                    <AntDesign name="down" size={15} color="#A5A5A5" />
                  </View>
                </View>
              </TouchableOpacity>
              <View style={styles.hiddenInfoContainer}>
                {shouldShowId == 0 ? (
                  <Text style={styles.textSectionStyle}>
                    {offer.advertiserAboutUs}
                  </Text>
                ) : null}
              </View>
              <View style={styles.betweenLineContainer}></View>
              <TouchableOpacity
                showId={shouldShowId == 1}
                onPress={() =>
                  shouldShowId == 1
                    ? setShouldShowIndex(-1)
                    : setShouldShowIndex(1)
                }
              >
                <View style={styles.upInfoContainer}>
                  <View style={styles.upInfoLeftContainer}>
                    <Text style={styles.infoLink}>Terms and Conditions</Text>
                  </View>
                  <View style={styles.arrowRightContainer}>
                    <AntDesign name="down" size={15} color="#A5A5A5" />
                  </View>
                </View>
              </TouchableOpacity>
              <View style={styles.hiddenInfoContainer}>
                {shouldShowId == 1 ? (
                  <Text
                    style={[styles.textSectionStyle, { marginBottom: 10 }]}
                  >
                    {offer.terms}
                  </Text>
                ) : null}
              </View>
              <View style={styles.betweenLineContainer}></View>
            </View>
          </View>
        </View>
      </ScrollView >
      <View style={GlobalStyles.webFooter}>
        {/* {win.width > 768 ? <FooterBarWide /> : null} */}
      </View>
    </View >
  );
}
const styles = StyleSheet.create({
  imageThumbnail: {
    height: 46,
    width: "100%",
    resizeMode: "contain",
    margin: 1,
  },
  imageThumbnailPadding: {
    minWidth: 80,
  },
  scrollArea: {
    backgroundColor: "#ffffff",
  },
  investedDetail: {
    fontFamily: "montserrat-regular",
    fontSize: 20,
    paddingTop: 10,
    paddingBottom: 10,
    color: Colors.WHITE,
  },
  investedDetailContainer: {
    flex: 1,
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    backgroundColor: "#4EBDEF",
    marginTop: -10,
    paddingLeft: 0,
    paddingRight: 0,
    paddingTop: 5,
    paddingBottom: 5,
    height: 87,
  },
  investedTopCotainer: {
    marginTop: 25,
  },
  investedTextContainer: {
    flex: 1,
    alignContent: "flex-start",
    marginLeft: 15,
  },
  favouriteIconContainer: {
    alignContent: "flex-end",
    marginRight: 15,
  },
  descriptionDetail: {
    fontFamily: "montserrat-regular",
    fontSize: 13,
    textAlign: "left",
    marginBottom: 15,
    marginTop: 30,
    paddingLeft: 30,
    paddingRight: 30,
    lineHeight: 20,
    color: Colors.DARKGRAY,
  },
  fixedTextContainer: {
    borderColor: Colors.LIGHTGRAY,
    paddingBottom: 10,
    //marginTop: 15,
    paddingLeft: 30,
    paddingRight: 30,
  },
  bodyIntro: {
    fontFamily: "montserrat-italic",
    fontSize: 13,
    textAlign: "left",
    marginBottom: 30,
    marginTop: 30,
    color: Colors.DARKGRAY,
    lineHeight: 20,
  },
  bodyStyle: {
    fontFamily: "montserrat-regular",
    fontSize: 12,
    textAlign: "left",
    marginBottom: 5,
  },
  bodyStyleShopInfo: {
    fontFamily: "montserrat-regular",
    fontSize: 13,
    textAlign: "left",
    marginBottom: 5,
    paddingTop: 30,
    paddingBottom: 30,
    color: "#998FA2",
    lineHeight: 20,
  },
  arrowRightContainer: {
    flex: 1,
    alignItems: "flex-end",
  },
  bigImageThumbnail: {
    height: 300,
    width: "100%",
    resizeMode: "cover",
  },
  imageContainer: {
    width: "100%",
  },
  textStyle: {
    color: "#000",
    textAlign: "center",
    fontFamily: "montserrat-bold",
    fontSize: 14,
  },
  SubmitButtonStyle: {
    paddingTop: 15,
    paddingBottom: 15,
    backgroundColor: "#FFC72C",
    borderRadius: 30,
    marginBottom: 10,
    marginTop: 40,
    width: 150,
  },
  buttonContainer: {
    flex: 1,
    flexDirection: "row",
    alignSelf: "center",
    marginTop: 60,
  },
  cardButtonContainer: {
    flex: 1,
    flexDirection: "row",
    paddingLeft: 40,
    paddingRight: 40,
    marginTop: 20,
  },
  linkedcard: {
    flex: 1,
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
  },
  NotLinkedcard: {
    flex: 1,
    flexDirection: "row",
    justifyContent: "center",
    borderRadius: 50,
    backgroundColor: Colors.MIDBLUE,
    height: 52,
    width: 302,
    alignItems: "center",
  },
  NotLinkedCardTextStyle: {
    fontSize: 14,
    color: Colors.WHITE,
    fontFamily: "montserrat-bold",
    textAlign: "center",
  },
  linkedCardTextStyle: {
    fontSize: 16,
    color: Colors.MIDBLUE,
    fontFamily: "montserrat-bold",
  },
  buttonContainerNonR: {
    flex: 1,
    flexDirection: "row",
    alignSelf: "center",
    marginTop: 30,
    paddingLeft: 30,
    paddingRight: 30,
  },
  SubmitButtonStyleContinue: {
    borderRadius: 50,
    flex: 1,
    backgroundColor: Colors.YELLOW,
    color: "#000000",
    height: 52,
    width: 302,
    justifyContent: "center",
  },
  infoLinkContainer: {
    flex: 1,
    flexDirection: "column",
    marginBottom: 50,
    // backgroundColor: "green",
    paddingLeft: 10,
    paddingRight: 10,
    marginTop: 60,
  },
  arrowRightContainer: {
    flex: 1,
    alignItems: "flex-end",
  },
  upInfoContainer: {
    flexDirection: "row",
    paddingTop: 18,
    paddingBottom: 18,
    borderColor: Colors.LIGHTGRAY,
  },
  betweenLineContainer: {
    borderTopWidth: 1,
    borderColor: Colors.LIGHTGRAY,
  },
  mapContainer: {
    flex: 1,
  },
  map: {
    width: "100%",
    height: 200,
  },
  hiddenInfoContainer: {
    paddingTop: 5,
    paddingBottom: 5,
  },
  textSectionStyle: {
    fontFamily: "montserrat-regular",
    fontSize: 13,
    textAlign: "left",
    lineHeight: 20,
  },
  textLocationStyle: {
    fontFamily: "montserrat-regular",
    fontSize: 13,
    textAlign: "left",
    lineHeight: 20,
    paddingBottom: 10,
  },
  infoLink: {
    fontFamily: "montserrat-medium",
    fontSize: 13,
    paddingRight: 10,
    color: Colors.DARKGRAY,
  },
  rightTopBodyContainer: {
    flexDirection: "row",
    alignItems: "center",
  },
});